import { useAuth } from "@/contexts/AuthContext";
import { getRuntimeEnvironment } from "@/utils/helpers/runtimeEnvironment";

export type TMenuItem = {
  title: string;
  path?: string;
  activePaths?: string[];
  hidden?: boolean;
  children?: TMenuItem[];
};

const runtime = getRuntimeEnvironment();
const isLocal = runtime.isLocal;
const isStaging = runtime.isStaging;
const isProduction = runtime.isProduction;

function useNavItems() {
  const { user, is_logged_in, status, logout } = useAuth();

  const NAV_ITEMS: TMenuItem[] = [
    {
      title: "Properties",
      path: "/properties",
      activePaths: ["/properties", "/property"],
    },
    {
      title: "Managed Properties",
      path: "/managed-properties",
      activePaths: ["/managed-properties"],
    },
    {
      title: "Managed Developments",
      path: "/managed-developments",
      activePaths: ["/managed-developments"],
      hidden: isStaging || isProduction,
    },
    {
      title: "Deals",
      path: "/weekly-deals",
      activePaths: ["/weekly-deals"],
    },
    {
      title: "Property Request",
      path: "/request-property",
      activePaths: ["/request-property"],
    },
    {
      title: "Realtors",
      path: "/realtors",
      activePaths: ["/realtors"],
    },
    {
      title: "Developers",
      path: "/developers",
      activePaths: ["/developers"],
    },
    {
      title: "Blog",
      path: "https://blog.findnigeriaproperties.com",
      activePaths: [],
    },
    {
      title: "Contact Us",
      path: "/contact",
      activePaths: ["/contact"],
    },
  ];

  const navItems = NAV_ITEMS.filter((item) => !item.hidden);

  return { navItems, allItems: NAV_ITEMS, user, is_logged_in, status, logout };
}

export default useNavItems;
